import React from "react";
import cns from "classnames";
import Typography, { TypographyProps } from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";
import { darken } from "polished";

type Props = TypographyProps & {
  clickable?: boolean;
};

export function Subheading(props: Props) {
  const { className, clickable, children, ...rest } = props;
  const classes = useStyles({});

  return (
    <Typography
      {...rest}
      variant="subtitle1"
      className={cns(classes.root, className, {
        [classes.clickable]: clickable
      })}
    >
      {children}
    </Typography>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    fontWeight: theme.fontWeight.bold
  },

  clickable: {
    color: theme.palette.secondary.main,
    cursor: "pointer",
    textDecoration: "underline",
    transition: theme.transitions.create("color"),

    "&:hover, &:active": {
      color: darken(0.1, theme.palette.secondary.main)
    }
  }
}));
